import { Helmet } from 'react-helmet-async'

export default function SEO({
  title = 'Lloyd James Data Consultancy',
  description = 'Professional data consultancy services for businesses. Expert data management, analysis, and strategic insights.',
  keywords = 'data consultancy, data management, business intelligence, data analysis, Lloyd James',
  ogImage = '/images/lloyd-james-data-consultancy-logo.webp',
  ogUrl = '',
  canonical = '',
  type = 'website',
  twitterCard = 'summary_large_image',
  structuredData = null
}) {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.lloydjames.com'
  const fullOgUrl = ogUrl || siteUrl
  const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`
  // Falls back to fullOgUrl when no canonical is given, preserving prior behaviour
  // for callers that don't pass this prop.
  const canonicalUrl = canonical
    ? (canonical.startsWith('http') ? canonical : `${siteUrl}${canonical}`)
    : fullOgUrl

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullOgUrl} />
      <meta property="og:image" content={fullOgImage} />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonicalUrl} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  )
}